import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { minorScale, Pane, Icon, Heading, Tooltip } from 'evergreen-ui'

export default class Group extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    style: PropTypes.any,
    height: PropTypes.number,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    tooltip: PropTypes.string,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func
  }

  render() {
    const {
      label,
      style,
      height,
      icon,
      iconColor,
      tooltip,
      isOpen,
      onToggle
    } = this.props

    return (
      <Pane
        style={style}
        height={height}
        background="tint1"
        display="flex"
        alignItems="center"
        borderBottom="muted"
        cursor="pointer"
        onClick={onToggle}
      >
        <Pane flex="1" display="flex" alignItems="center">
          <Icon
            icon={isOpen ? 'caret-up' : 'caret-down'}
            marginX={minorScale(3)}
            size={12}
          />

          <Heading size={100} fontWeight={500} color="muted">
            {label}
          </Heading>
        </Pane>

        {icon && (
          <Tooltip content={tooltip}>
            <Icon
              icon={icon}
              size={minorScale(3)}
              color={iconColor}
              marginRight={8}
            />
          </Tooltip>
        )}
      </Pane>
    )
  }
}
